module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-voucher"
  }, [_c('div', {
    staticClass: "bc-voucher__inner"
  }, [_c('a', {
    staticClass: "bc-voucher__back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("\n      ← " + _vm._s(_vm.$T('观众中心返回')) + "\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "bc-voucher__title"
  }, [_vm._v(_vm._s(_vm.$T('观众中心上传付款凭证')))]), _vm._v(" "), _c('p', {
    staticClass: "bc-voucher__desc"
  }, [_vm._v(_vm._s(_vm.$T('观众中心上传付款凭证说明')))]), _vm._v(" "), (_vm.account.beneficiary_account) ? _c('section', {
    staticClass: "bc-voucher__card"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$T('观众中心收款账号')))]), _vm._v(" "), _c('p', {
    staticClass: "bc-voucher__line"
  }, [_c('span', [_vm._v("Account")]), _vm._v("\n        " + _vm._s(_vm.account.beneficiary_account) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "bc-voucher__line"
  }, [_c('span', [_vm._v("Beneficiary")]), _vm._v("\n        " + _vm._s(_vm.account.beneficiary_name) + "\n      ")]), _vm._v(" "), (_vm.payPrice) ? _c('p', {
    staticClass: "bc-voucher__amount"
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心应付')) + "："), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.payPrice)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "bc-voucher__card"
  }, [_c('div', {
    staticClass: "bc-voucher__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心汇款时间')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pay_off_date),
      expression: "form.pay_off_date"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$T('观众中心汇款时间占位')
    },
    domProps: {
      "value": (_vm.form.pay_off_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pay_off_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-voucher__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心汇款单号')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pay_off_id),
      expression: "form.pay_off_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$T('观众中心汇款单号占位')
    },
    domProps: {
      "value": (_vm.form.pay_off_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pay_off_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-voucher__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心付款截图')) + " "), _c('em', [_vm._v("*")])]), _vm._v(" "), _c('PicUploader', {
    attrs: {
      "fileList": _vm.form.order_pics,
      "limit": 3,
      "multiple": true
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bc-voucher__tip"
  }, [_vm._v(_vm._s(_vm.$T('观众中心付款截图提示')))])], 1), _vm._v(" "), _c('button', {
    staticClass: "bc-voucher__submit",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心提交凭证')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-642b13d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorOfflineVoucher.vue
// module id = 1493
// module chunks = 0